var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "theam-layout" }, [
      _c("div", { staticClass: "theam-layout-event-content" }, [
        _c("div", { staticClass: "theam-layout-event-content__old" }, [
          _c(
            "span",
            { staticClass: "theam-layout-event-content__old-value" },
            [
              _c("strike", [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.event.Event.Market.Option[_vm.priceboostSelection][
                        "@odds"
                      ]
                    ) +
                    " "
                )
              ])
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "theam-layout-event-content__new" }, [
          _c("span", { staticClass: "theam-layout-event-content__new-value" }, [
            _vm._v(
              _vm._s(_vm.scContent.FieldValues.Parameters["copy_now-odds"])
            )
          ])
        ])
      ]),
      _vm._v(" "),
      !_vm.scContent.FieldValues.Parameters["jersey_img"]
        ? _c("div", { staticClass: "theam-layout-images" }, [
            _c("div", { staticClass: "theam-layout-images-block" }, [
              _c("img", {
                staticClass: "theam-layout-images-block-one",
                attrs: { src: _vm.teamShirt, alt: "" },
                on: {
                  "~error": function($event) {
                    return _vm.handleImageError($event)
                  }
                }
              })
            ])
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "theam-content" }, [
      _c("div", [
        _c("div", { staticClass: "promo-header" }, [
          _c("header", {
            domProps: {
              innerHTML: _vm._s(_vm.scContent.FieldValues.Parameters["title"])
            }
          })
        ]),
        _vm._v(" "),
        _c("div", [
          _c("span", {
            staticClass: "sub-header",
            domProps: {
              innerHTML: _vm._s(
                _vm.scContent.FieldValues.Parameters["copy_claim"]
              )
            }
          })
        ]),
        _vm._v(" "),
        _c("br"),
        _vm._v(" "),
        _c("div", [
          _c(
            "a",
            {
              staticClass: "button button--primary",
              staticStyle: { "text-transform": "capitalize" },
              attrs: { href: _vm.scContent.FieldValues.Parameters["link_cta"] }
            },
            [_vm._v("Bet Now")]
          )
        ]),
        _vm._v(" "),
        _c("br")
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "event__details" }, [
      _c("p", { staticStyle: { color: "white" } }, [
        _vm._v(
          " " +
            _vm._s(_vm.eventDate) +
            " " +
            _vm._s(_vm.event.Event["@name"]) +
            " "
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2273c678", { render: render, staticRenderFns: staticRenderFns })
  }
}